module.exports = __webpack_public_path__ + "static/mo01-6480f7cef73a066e7e29e600a693abbe.png";